module.exports = __webpack_public_path__ + "static/media/04.f895ea51.jpg";